import React, { useState } from 'react';

const EditBrandForm = ({ brandId, onBrandUpdated }) => {
  const [newName, setNewName] = useState('');

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/brands/${brandId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: newName }),
      });

      if (response.ok) {
        const updatedBrand = await response.json();
        onBrandUpdated(updatedBrand);

        // Clear the input field and show an alert
        setNewName('');
        alert('Portfolio successfully updated');
      } else {
        console.error('Error updating brand:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating brand:', error);
    }
  };

  return (
    <div className="flex items-center gap-2" style={{ fontFamily: "Muli" }}>
      <input
        type="text"
        placeholder="New name"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && newName.trim() && handleEditSubmit()}
        className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-gray-900 focus:ring-2 focus:ring-gray-900/10"
      />
      <button
        onClick={handleEditSubmit}
        disabled={!newName.trim()}
        className="rounded-lg bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-600 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
      >
        Update
      </button>
    </div>
  );
};

export default EditBrandForm;